import React from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import LiveFloorViewApi from '../../api/livefloorview';
import { setAuthorise } from '../../redux/actions/installations';
import DataGrid from '../shared/DataGrid';
import MachineStatusFilters from './MachineStatusFilters';
import { showLiveFloorViewDetailsModal } from '../../redux/actions/modals';

class MachineStatusTab extends React.Component {
  state = {
    filters: [],
    statuses: {
      online: false,
      offlineSiteOpen: true,   
      pending: false,
      authReq: true,
      offlineSiteClosed: false,
      onlineEFTDisabled: false,
      onlineNoFunds: false,
    },
    quantities: {
      onlineQty: 0,
      onlineEFTEnabledQty: 0,
      offlineSiteOpenQty: 0,
      pendingQty: 0,
      authReqQty: 0,
      offlineSiteClosedQty: 0,
      unknownQty: 0,
      onlineEFTDisabledQty: 0,
      onlineNoFundsQty: 0,
    },
    grid: {
      rowDef: [],
      headerDef: [],
      data: []
    },
    authorise: false,
    loading: false,
    currentInstallation: { installationId: null },
  };

  handleCommsViewSelection = currentInstallation => {
    this.setState({ currentInstallation }, () => this.props.showLiveFloorViewDetailsModal(currentInstallation));
  }

  handleAuthorise = async () => await this.props.setAuthorise(this.state.currentInstallation.installationId).then(() => this.handleRefresh());

  handleFilterChange = (option, value) => {
    const filters = [...this.state.filters];
    const index = filters.findIndex(control => control.code === option.code);
    filters[index] = option;
    this.setState({ filters }, () => this.handleLoadFilters());
  }

  handleStatusChange = (key, value) => {
    let statuses = {...this.state.statuses};
    statuses[key]=!statuses[key];
    this.setState({ statuses });
  }

  handleRefresh = () => {
    this.setState({loading: true }, () => {
      const { operator, company, subcompany, site } = this.props.filters.filterSelected
      const { filters, statuses } = this.state;
      LiveFloorViewApi.filterByMachine(
        operator,
        company.id,
        subcompany.id,
        site.id,
        filters,
        statuses
      ).then(
        data => this.setState(
          { 
            grid: data.grid,
            quantities: {
              ...this.state.quantities,
              // Spread only the items from the response that are already in the original quantities object, it's unnecessary, but it just keeps clean data. 
              ...Object.fromEntries(Object.entries(data).filter(([key]) => Object.keys(this.state.quantities).includes(key))) 
            }, 
            loading: false 
          }
        ), 
        () => this.setState({ loading: false })
      );
    });
  }

  handleLoadFilters = () => {
    const { operator } = this.props.filters.filterSelected;
    LiveFloorViewApi.getFilters(operator, this.state.filters).then(filters => this.setState({ filters }))
  }

  componentDidUpdate(prevProps, prevState) {
    const { operator } = this.props.filters.filterSelected;
    if (operator && operator !== prevProps.filters.filterSelected.operator) {
      this.handleLoadFilters();
    }

    if (this.props.filters.hasSelection && !prevProps.filters.hasSelection) {
      this.handleRefresh();
    }
  }

  render() {
    const { filters, statuses, quantities, authorise } = this.state;

    return (
      <Grid relaxed className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column width="16">
            <MachineStatusFilters 
              onChange={this.handleChange}
              onStatusChange={this.handleStatusChange}
              onFilterChange={this.handleFilterChange}
              onRefreshClick={this.handleRefresh}
              filters={filters}
              statuses={statuses}
              quantities={quantities}
              allowAuthorise={authorise}
              onAuthoriseClick={this.handleAuthorise}
              disabled={!this.props.filters.hasSelection}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="flex-stretch">
          <Grid.Column className="gs-flex-container-vertical">
            <DataGrid
              loading={this.state.loading}
              headings={this.state.grid.headerDef}
              rowDef={this.state.grid.rowDef}
              data={this.state.grid.data}
              onRowClick={this.handleCommsViewSelection}
              fullHeight
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};

const mapStateToProps = state => {
	return {
    filters: state.LiveFloorViewerFilters,
  };
};

export default connect(mapStateToProps, { showLiveFloorViewDetailsModal, setAuthorise })(MachineStatusTab);
